export default __webpack_public_path__ + "static/media/lava.ac2abc58.png";